import { handleRequest } from "../../axios";
import { axiosInstance } from "./JsdhNotifikaceService";
import {
    ADMIN_EXTERNI_KONTAKTY_URL,
    ADMIN_EXTERNI_KONTAKT_BY_ID_URL,
    ADMIN_RODINNY_PIN_URL,
    RODINNY_PIN_URL,
} from "../url";
import type {
    ExterniKontakt,
    ExterniKontaktRequest,
    RodinnyPinStatus,
} from "../generated/models/ExterniKontakt";

const getAll = () =>
    handleRequest<ExterniKontakt[]>(() => axiosInstance.get(ADMIN_EXTERNI_KONTAKTY_URL));

const create = (data: ExterniKontaktRequest) =>
    handleRequest<ExterniKontakt>(() => axiosInstance.post(ADMIN_EXTERNI_KONTAKTY_URL, data));

const update = (id: number, data: ExterniKontaktRequest) =>
    handleRequest<ExterniKontakt>(() => axiosInstance.put(ADMIN_EXTERNI_KONTAKT_BY_ID_URL(id), data));

const remove = (id: number) =>
    handleRequest(() => axiosInstance.delete(ADMIN_EXTERNI_KONTAKT_BY_ID_URL(id)));

// Rodinny PIN - admin per clen
const getAdminPinStatus = (userId: number) =>
    handleRequest<RodinnyPinStatus>(() => axiosInstance.get(ADMIN_RODINNY_PIN_URL(userId)));
const generateAdminPin = (userId: number) =>
    handleRequest<{ pin: string }>(() => axiosInstance.post(ADMIN_RODINNY_PIN_URL(userId)));
const invalidateAdminPin = (userId: number) =>
    handleRequest(() => axiosInstance.delete(ADMIN_RODINNY_PIN_URL(userId)));

// Rodinny PIN - self-service
const getMyPinStatus = () =>
    handleRequest<RodinnyPinStatus>(() => axiosInstance.get(RODINNY_PIN_URL));
const generateMyPin = () =>
    handleRequest<{ pin: string }>(() => axiosInstance.post(RODINNY_PIN_URL));
const invalidateMyPin = () =>
    handleRequest(() => axiosInstance.delete(RODINNY_PIN_URL));

const ExterniKontaktyService = {
    getAll, create, update, remove,
    getAdminPinStatus, generateAdminPin, invalidateAdminPin,
    getMyPinStatus, generateMyPin, invalidateMyPin,
};
export default ExterniKontaktyService;
